import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { usePublicCycle } from "@/context/PublicCycleContext";

interface PublicCycleLayoutProps {
  children: ReactNode;
}

export function PublicCycleLayout({ children }: PublicCycleLayoutProps) {
  const { t } = useTranslation();
  const { session } = usePublicCycle();

  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground relative">
      <header className="relative z-10 border-b border-border/60 bg-background/90 backdrop-blur-md">
        <div className="mx-auto flex max-w-[1400px] items-center justify-between gap-3 px-4 py-3 md:px-8">
          <div className="min-w-0">
            <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">
              {t("v2.home.publicHomeBadge")}
            </p>
            <p className="truncate text-base font-bold">{session?.groupName ?? "Fulbito"}</p>
          </div>
          <p className="shrink-0 text-sm text-muted-foreground">{session?.playerName}</p>
        </div>
      </header>
      <main className="relative z-10 flex-1">
        <div className="mx-auto max-w-[1400px] animate-fade-in space-y-6 p-4 md:px-8 md:py-8">
          {children}
        </div>
      </main>
    </div>
  );
}
